module.exports = __webpack_public_path__ + "img/img31.17ba2fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/02/img31.png
// module id = 209
// module chunks = 0